<template>
    <div v-if="global.candidate!=null" class="row">
        <q-scroll-area class="col" style="height: calc(100vh - 345px);max-width:300px;">
            <!-- <div class="col" style="max-width:300px;"> -->
            <!-- <img :src="portait()" style="max-height: 200px; max-width: 150px;" /> -->

            <q-img :src="face()" spinner-color="white" style="width:100px;" :alt="imageUrlAlt()">
                <!-- <q-badge rounded color="red" :label="ratingNumber()" /> -->
            </q-img>


            <div class="q-mt-sm">
                <div class="text-h6">{{global.candidate.Name}}</div>
                <div class="text-subtitle1 text-weight-bold text-red">Republican</div>
                <div class="text-subtitle1">Office: {{global.candidate.Office}}</div>
                <div class="text-subtitle1">District: {{global.candidate.District}}</div>
                <div v-if="global.candidate['YrElected']" class=" text-subtitle1">Year
                    Elected:{{global.candidate['YrElected']}}
                </div>
                <a :href="'mailto:' + global.candidate.Email" class="text-subtitle1">{{global.candidate.Email}}</a>
                <div class="text-subtitle1">{{global.candidate.Phone}}</div>
                <a :href="global.candidate.Web" target="_blank" rel="noopener noreferrer"
                    class="text-subtitle1">{{global.candidate.Web}}</a>
                <!-- <q-rating v-model="global.candidate.rating" :readonly="true" size="1.5em" max="6" color="red" /> -->

            </div>

        </q-scroll-area>



        <div v-if="global.candidate.Notes" class="col">
            <div>NOTES:</div>

            <p class="text-grey">{{global.candidate.Notes}}</p>

        </div>

    </div>




</template>

<script>
    import { global } from './Global.js';


    export default {
        name: 'Details',
        data() {
            return {
                candidate: global.candidate,
                // portaitSrc:"",

                global
            }

        },
        methods: {
            imageUrlAlt() {
                return "../assets/img/Avatar.jpg";
            },
            face() {

                if (!this.global.candidate) return "";

                let name = this.global.candidate.Name;

                try {
                    name = require("../assets/img/" + name + ".jpg");
                }
                catch (err) {
                    return require("../assets/img/Avatar.jpg");
                }


                return name;
            }
        }
        // methods: {
        //     ratingNumber() {

        //         const rating = Math.round(global.candidate.rating / 6 * 100);

        //         return rating + "%";
        //     }
        // }

    }
</script>